import { Link, Icon, IconSize } from '@alto-avios/alto-ui'
import React, { type JSX } from 'react'
import styles from './ExternalLink.module.scss'

type ExternalLinkProps = {
  readonly linkTarget: string
  readonly linkText: string
  variant?: 'default' | 'lineItemLink'
  icon?: string
  iconSize?: IconSize
}

function ExternalLink({
  linkTarget,
  linkText,
  variant = 'default',
  icon,
  iconSize,
}: ExternalLinkProps): JSX.Element {
  const className = variant === 'lineItemLink' ? styles.lineItemLink : styles.defaultLink

  return (
    <Link
      href={linkTarget}
      iconEndProps={false}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
    >
      {linkText}
      {icon && <Icon iconName={icon} iconSize={iconSize} />}
    </Link>
  )
}

export default ExternalLink
